import cookieService from '@/modules/cookieService'
import { validLocales } from '@/modules/langService/validLocales'

function clientGetLocale () {
  let locale = cookieService.getCookie('NEXT_LOCALE') || 'en'

  if (!validLocales.includes(locale)) {
    locale = 'en'
  }

  return locale
}

export default clientGetLocale
